import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ComparisonToggleTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonToggle.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: ComparisonToggleTrackingInfo) => {
    const event: TypedAnalyticsEvent<ComparisonToggleTrackingInfo> = {
        event: EventType.ComparisonToggle,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackOpen = () => {
    track({
        action: "open"
    });
};

export const trackClose = () => {
    track({
        action: "close"
    });
};
